import { jwtDecode } from 'jwt-decode';
import { useState } from 'react';
import axios from 'axios';
import BASE_URL, { IMAGE_DOMAIN } from '../../config/config';

const FotoPerfil = () => {
    const token = localStorage.getItem("AuthToken");
    let tokenInfo = {};

    if (token) {
        tokenInfo = jwtDecode(token);
    }

    const [profilePicUrl, setProfilePicUrl] = useState(
        tokenInfo.fotoPerfil ? (tokenInfo.fotoPerfil.startsWith('http') ? tokenInfo.fotoPerfil : `${IMAGE_DOMAIN}${tokenInfo.fotoPerfil}`) : `${IMAGE_DOMAIN}/images/usuario.png`
    );

    const handleFileChange = async (e) => {
        const file = e.target.files[0];

        if (file) {
            const formData = new FormData();
            formData.append('fotoPerfil', file);

            try {
                const response = await axios.put(
                    `${BASE_URL}/usuario/actualizar-imagen/${tokenInfo.usuario}`,
                    formData,
                    {
                        headers: {
                            'Authorization': token,
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );

                if (response.data.success) {
                    // **Actualizar la imagen de perfil**
                    const newFotoPerfil = response.data.user.fotoPerfil;
                    setProfilePicUrl(newFotoPerfil.startsWith('http') ? newFotoPerfil : `${IMAGE_DOMAIN}${newFotoPerfil}`);

                    // **Actualizar el token en localStorage**
                    localStorage.setItem("AuthToken", response.data.token);

                    alert("Imagen actualizada correctamente.");
                    window.location.reload(); // Recargar la página para aplicar el nuevo token
                } else {
                    alert(response.data.message);
                }
            } catch (error) {
                console.error('Error al actualizar la imagen:', error);
                alert("Error al actualizar la imagen.");
            }
        }
    };

    return (
        <div className='grid-profile-pic'>
            <img src={profilePicUrl || `${IMAGE_DOMAIN}/images/usuario.svg`} alt="Foto Perfil" className="profile-pic" />
            <label className="update-profile-pic">
                <img src="/images/circulo.svg" alt="Lápiz" />
                <input type="file" accept="image/*" onChange={handleFileChange} />
            </label>
        </div>
    );
};

export default FotoPerfil;